var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.359 6.186c.577.386 6.18 4.336 8.91 6.262l-1.686 1.686-2.408-1.686-5.299 4.577v-2.89c.883-.563 2.746-1.783 3.131-2.168.482-.482.723-.964-1.445-2.409-1.734-1.156-2.328.16-2.408.964-.16 2.167-.434 7.08-.241 9.393.192 2.312 1.846 1.926 2.65 1.445 6.1-4.737 18.785-14.547 20.712-15.896s2.73.562 2.89 1.686c.401 2.81 1.108 9.634.723 14.45-.483 6.022-3.614 3.854-6.023 2.89-1.926-.77-5.78-4.334-7.466-6.02l1.928-1.445c.482.642 2.168 2.312 5.058 3.853 2.89 1.542 3.452.16 3.372-.722.08-2.007.096-6.648-.482-9.153-.578-2.504-2.489-1.525-3.372-.722l-5.78 4.818C13.708 18.71 4.54 26.032 3.19 26.418c-1.348.385-2.006-1.767-2.166-2.89V8.353c-.08-.16 0-.867.963-2.408 1.204-1.927 2.65-.241 3.372.24z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlp);
export default __webpack_public_path__ + "static/media/SLP.7346d8097f243c3bc78b53dc81af4f81.svg";
export { ForwardRef as ReactComponent };